import React from 'react';
import { Headphones, Radio, Sliders, Layers } from 'lucide-react';

/**
 * Cards no estilo "imagem grande com overlay":
 * - Imagem de fundo do tema
 * - Badge amarelo no canto superior direito (FUNDAMENTO / ESSENCIAL / AVANÇADO / PRO)
 * - Ícone amarelo no canto superior esquerdo
 * - Título grande em branco + descrição
 *
 * Os textos foram condensados dos 6 módulos existentes em 4 pilares temáticos.
 */
const LEARN_CARDS = [
  {
    badge: 'FUNDAMENTO',
    icon: Headphones,
    title: 'LÓGICA DA CONSOLE',
    desc:
      'Antes de apertar qualquer botão, você precisa entender como a console foi pensada. Aqui você vai aprender a enxergar o fluxo do áudio de forma simples — anatomia da WING, fader banks, layers e organização de Input/Output List.',
    bgImage:
      'https://customer-assets.emergentagent.com/job_207ce1a1-cc0d-4cea-b992-9f78cf5204d4/artifacts/r26t3ydk_Logica%20da%20console.jpeg',
  },
  {
    badge: 'ESSENCIAL',
    icon: Radio,
    title: 'ROTEAMENTOS',
    desc:
      'Depois de entender a lógica, o próximo passo é aprender como direcionar o som dentro da console para PA, gravação, transmissão e retornos — Sources, AES50, Stage Connect e redes TCP/IP.',
    bgImage:
      'https://customer-assets.emergentagent.com/job_207ce1a1-cc0d-4cea-b992-9f78cf5204d4/artifacts/ovy2eemg_Roteamento.jpeg',
  },
  {
    badge: 'AVANÇADO',
    icon: Sliders,
    title: 'PROCESSAMENTOS',
    desc:
      'Aqui entramos na parte de processamento do áudio. Você vai dominar dinâmicos, equalização, inserts e a estrutura de processamento — incluindo efeitos premium, processamento de canal e de bus.',
    bgImage:
      'https://customer-assets.emergentagent.com/job_207ce1a1-cc0d-4cea-b992-9f78cf5204d4/artifacts/yi534v93_Processamento.jpeg',
  },
  {
    badge: 'PRO',
    icon: Layers,
    title: 'ESTRUTURA DE MIXAGEM',
    desc:
      'Por fim, vamos entender como organizar uma mixagem profissional com clareza, controle e rapidez durante eventos — DCAs, Sub Grupos, compressão paralela, Plano X, mix de PA e monitor.',
    bgImage:
      'https://customer-assets.emergentagent.com/job_207ce1a1-cc0d-4cea-b992-9f78cf5204d4/artifacts/pwkv3r3r_Estrutura%20de%20mixagem.jpeg',
  },
];

const Modules = () => {
  return (
    <section id="modulos" className="section-padding bg-black relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-3 md:mb-4">
              O que você vai <span className="gradient-text">aprender</span>
            </h2>
            <p className="text-base md:text-xl text-gray-400">
              4 pilares essenciais para você dominar a Console WING
            </p>
          </div>

          {/* Grid de cards estilo "imagem + overlay" */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            {LEARN_CARDS.map((card) => {
              const Icon = card.icon;
              return (
                <article
                  key={card.badge}
                  data-testid={`learn-card-${card.badge.toLowerCase()}`}
                  className="group relative rounded-2xl overflow-hidden bg-neutral-900 border border-white/5 aspect-[4/5] sm:aspect-[16/13] md:aspect-[5/4] flex"
                >
                  {/* Imagem de fundo */}
                  <img
                    src={card.bgImage}
                    alt={card.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-50 group-hover:scale-105 transition-all duration-700 ease-out"
                  />
                  {/* Overlay gradiente — escurece a base pro texto ficar legível */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/20" />

                  {/* Conteúdo */}
                  <div className="relative z-10 w-full flex flex-col justify-between p-5 md:p-7">
                    {/* Top: ícone + badge */}
                    <div className="flex items-start justify-between">
                      <div className="w-11 h-11 md:w-12 md:h-12 bg-yellow-400 rounded-xl flex items-center justify-center shadow-lg shadow-yellow-500/20">
                        <Icon className="w-5 h-5 md:w-6 md:h-6 text-black" strokeWidth={2.5} />
                      </div>
                      <span className="bg-yellow-400 text-black text-[10px] md:text-xs font-black tracking-[0.15em] px-3 py-1.5 rounded-md">
                        {card.badge}
                      </span>
                    </div>

                    {/* Bottom: título + desc */}
                    <div>
                      <h3 className="text-white font-bold text-xl sm:text-2xl md:text-3xl mb-3 leading-tight">
                        {card.title}
                      </h3>
                      <p className="text-gray-300 text-sm md:text-base leading-relaxed">
                        {card.desc}
                      </p>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>

          {/* Bottom CTA */}
          <div className="mt-10 md:mt-14 text-center px-4">
            <p className="text-gray-400 text-sm md:text-base mb-4">
              Todo o conteúdo é apresentado de forma prática e aplicada ao seu dia a dia
            </p>
            <a
              href="#inscricao"
              className="inline-block w-full sm:w-auto bg-yellow-500 hover:bg-yellow-600 text-black px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold transition-all duration-300 hover:scale-105 glow-yellow"
            >
              QUERO DOMINAR A WING
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Modules;
